import { useQuery as r, useMutation as u } from "@tanstack/react-query";
import s from "./quiz.api.js";
import { teachurKeys as o } from "../../constants/teachurKeys.js";
const p = (t, e) => r({
  ...e,
  queryKey: o.quizzes.list(t == null ? void 0 : t.courseId),
  queryFn: async () => (await s.getAll(t)).data
}), z = (t) => u({
  ...t,
  mutationFn: async (e) => (await s.start(e)).data
}), d = (t) => u({
  ...t,
  mutationFn: async ({ quizId: e, data: n }) => (await s.update(e, n)).data
}), Q = (t) => u({
  ...t,
  mutationFn: async (e) => (await s.deleteByCourse(e)).data
});
export {
  p as useGetQuizzesQuery,
  Q as useResetQuizzesMutation,
  z as useStartQuizMutation,
  d as useSubmitQuizMutation
};
